import { SchoolSearchLoadingService } from "./SchoolSearchLoadingService";
import { SchoolSearchFilteringService } from "./SchoolSearchFilteringService";
import { SchoolSearchTrackingService } from "./SchoolSearchTrackingService";
import { NeedsBySchoolResolver } from "./NeedsBySchoolResolver";

export class SchoolSearchService {
    constructor(config) {
        this.config = config;
        this.loadingService = new SchoolSearchLoadingService(config);
    }

    async boot() {
        const { aws_s3_url, school, filterOptions, needs } = await this.loadingService.boot();

        this.filteringService = new SchoolSearchFilteringService(this.config, school, needs);
        this.trackingService = new SchoolSearchTrackingService(filterOptions, this.loadingService.positions, this.config.userId);
        const needsBySchool = NeedsBySchoolResolver.mapNeedsBySchools(needs);

        return {
            awsS3Url: aws_s3_url,
            schools: school,
            filterOptions: filterOptions,
            positions: this.loadingService.positions,
            needsBySchool,
        };
    }

    async filter(filterSet) {
        return await this.filteringService.filter(filterSet);
    }

    async segmentTrack(eventName, eventData) {
        return await this.trackingService.segmentTrack(eventName, eventData);
    }

    async trackInDb(appliedFilters, totalResults) {
        return await this.trackingService.trackInDb(appliedFilters, totalResults);
    }
}

export default new SchoolSearchService();